import * as React from "react";

function SvgPlateSchedule(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M4.25 11.333H8.5v4.25H4.25v-4.25zM11.333 11.333h4.25v4.25h-4.25v-4.25zM18.417 11.333h4.25v4.25h-4.25v-4.25zM25.5 11.333h4.25v4.25H25.5v-4.25zM4.25 18.417H8.5v4.25H4.25v-4.25zM11.333 18.417h4.25v4.25h-4.25v-4.25zM18.417 18.417h4.25v4.25h-4.25v-4.25zM25.5 18.417h4.25v4.25H25.5v-4.25zM4.25 25.5H8.5v4.25H4.25V25.5zM11.333 25.5h4.25v4.25h-4.25V25.5zM18.417 25.5h4.25v4.25h-4.25V25.5zM25.5 25.5h4.25v4.25H25.5V25.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.083 0h4.25v1.417h11.334V0h4.25v1.417h2.833A4.25 4.25 0 0134 5.667V34H0V5.667a4.25 4.25 0 014.25-4.25h2.833V0zM1.417 8.5v24.083h31.166V8.5H1.417z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlateSchedule;
